import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface MobileOnboardingProps {
  isVisible: boolean;
  onDismiss: () => void;
}
const MobileOnboarding: React.FC<MobileOnboardingProps> = ({
  isVisible,
  onDismiss
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onDismiss, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onDismiss]);
  return <AnimatePresence data-id="element-158">
      {isVisible && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onDismiss} className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm" data-id="element-159">
          <motion.div className="mx-6 p-8 rounded-3xl bg-white/70 backdrop-blur-xl shadow-lg border border-white/20" initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.95,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} data-id="element-160">
            <div className="space-y-6" data-id="element-161">
              <div className="flex items-center gap-3" data-id="element-162">
                <motion.span animate={{
              x: [-10, 0, -10]
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} className="text-gray-400" data-id="element-163">
                  ←
                </motion.span>
                <p className="text-gray-800 font-medium" data-id="element-164">
                  Links wischen: nächstes Projekt
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-165">
                <p className="text-gray-800 font-medium" data-id="element-166">
                  Rechts wischen: Projekt öffnen
                </p>
                <motion.span animate={{
              x: [0, 10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} className="text-gray-400" data-id="element-167">
                  →
                </motion.span>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};
export default MobileOnboarding;